import { render } from "./Wallpaper.vue?vue&type=template&id=5ad11dea&scoped=true"
import script from "./Wallpaper.vue?vue&type=script&lang=js"
export * from "./Wallpaper.vue?vue&type=script&lang=js"

import "./Wallpaper.vue?vue&type=style&index=0&id=5ad11dea&scoped=true&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad11dea"]])

export default __exports__